import { css } from 'styled-components';

export const updownTippyStyling = css`
  & {
    background-color: #ffffff;
    color: #141414;
    border: 2px solid #e7e7e7;
    border-radius: 2px;
    overflow: visible;
  }
  & .tippy-arrow {
    display: none;
  }
  &[data-animatefill] {
    background-color: #ffffff;
  }
  & .tippy-backdrop {
    background-color: transparent;
  }
  & .tippy-content {
    text-align: left;
  }
  &[x-placement^='top'] .tippy-arrow {
    border-bottom-color: #dddddd;
  }
  &[x-placement^='bottom'] .tippy-arrow {
    border-bottom-color: #dddddd;
  }
  &[x-placement^='left'] .tippy-arrow {
    border-left-color: #dddddd;
  }
  &[x-placement^='right'] .tippy-arrow {
    border-right-color: #dddddd;
  }
`;
